module.exports = __webpack_public_path__ + "i18n/fr.92d4844afc25c26e25f9465ce6bca0ca.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/fr.json
// module id = 1058
// module chunks = 60